module.exports = " <highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptions\" style=\"height: 450px; display: block;\">\n</highcharts-chart>"